export default "__VITE_ASSET__b208c9c8__"